import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ReturnsFlagKey = {
  EXCHANGE_RECOMMENDATION_PRESENTATION: featureFlagKey(
    "exchange-recommendation-presentation",
  ), // "off" | "popup" | "page". Per customer, teamId as an attribute. Default "off".
  INSPECT_BEFORE_REFUND: featureFlagKey("inspect-before-refund"), // Reorder processing to inspect/restock items before issuing refund
  MANAGED_RETURNS_TRIAL_ONBOARDING: featureFlagKey(
    "managed-returns-trial-onboarding",
  ), // Gate the Managed Returns trial onboarding to targeted merchant admins
  AUTO_SUBMIT_CLAIMS: featureFlagKey("auto-submit-claims"), // Auto Submit Claims; evaluated per submission method (method attribute in context)
  REQUEST_ADDITIONAL_CLAIM_DOCUMENTS: featureFlagKey(
    "request-additional-claim-documents",
  ), // Per-user (Redo employee email) gate for the request-additional-claim-documents return action. Default OFF.
  RETURN_PROCESSING_FLOWS: featureFlagKey("return-processing-flows"), // Enable advanced flow editor for return processing (replaces return/claim processing automations)
  INTERNATIONAL_RETURNS_READINESS: featureFlagKey(
    "international-returns-readiness",
  ), // Gate the intl-returns customs-readiness RPC/alert/banner. Default OFF.
  EXCHANGE_API_MULTIPLE_RETURNS: featureFlagKey(
    "exchange-api-multiple-returns",
  ), // Create separate Shopify returns for exchange-API return product groups. Per team, default OFF.
  SHOPIFY_RETURNS: featureFlagKey("shopify-returns"), // Shopify return lifecycle for exchange-API returns; per team, default "old".
  SHOPIFY_RETURNS_RETURNABLE_QUANTITY: featureFlagKey(
    "shopify-returns-returnable-quantity",
  ), // When ON, use non-Redo Shopify returns instead of refunds to determine remaining returnable quantity. Per team, default OFF.
  SHOPIFY_RETURNS_BILLING_ENFORCE: featureFlagKey(
    "shopify-returns-billing-enforce",
  ), // When ON: disable the customer portal for teams past the 14-day Shopify returns billing acceptance deadline
  NEW_EXCHANGE_FINANCIAL_STRATEGY: featureFlagKey(
    "new-exchange-financial-strategy",
  ), // Show exchange financial strategy card even when NONE; hide legacy dropdown
  PUBLIC_RETURN_REFUND_WITH_ORIGINAL_SHIPPING: featureFlagKey(
    "public-return-refund-with-original-shipping",
  ), // Include original-order shipping reimbursement in the public return refund total. Per team, default OFF.
  STORE_CREDIT_ON_SHOPIFY_RETURN: featureFlagKey(
    "store-credit-on-shopify-return",
  ), // Issue store credit on the Shopify return via returnProcess. Default OFF.
  APPEND_ORDER_METADATA_WITH_RETURN_DATA: featureFlagKey(
    "append-order-metadata-with-return-data",
  ), // Upsert return data to Shopify order metafield redo.return_info. Default OFF.
  SWITCH_TO_LUNA: featureFlagKey("switch-to-luna"), // Exchange agents use gpt-5.6-luna. Per team, default OFF.
  REDOJS_ORDER_SYNC: featureFlagKey("redojs-order-sync"), // Show the RedoJS order sync function in returns automation settings. Per team, default OFF.
  BULK_RETURN_ACTIONS: featureFlagKey("bulk-return-actions"), // Select returns in the table and run one action across them. Per team, default OFF.
  CONSOLIDATED_RETURNS_SETTINGS: featureFlagKey(
    "consolidated-returns-settings",
  ), // Show the consolidated tabbed Settings › Returns page. Per team, default OFF.
  CONSOLIDATED_RETURNS_SETTINGS_REQUIRED_FOR_REDO_USERS: featureFlagKey(
    "consolidated-returns-settings-required-for-redo-users",
  ), // Redo users get the consolidated Settings › Returns page by default and can still switch back. Per team, default OFF.
} as const;
